//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CanonMRUpdating",1,0],[0,"ImageFile",1,0],[0,"ImageUsage",1,0],[1,"SelectedObjects",0,"SelectNXObjectList",0]],[[[],"ClearMaskObjects",{},0,0]],[]];
SPLM.Display.CanonMRTestBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.CanonMRTestBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.CanonMRTestBuilder.ImageUsageType = Object.freeze({
    "None" : "None", "Dual" : "Dual", "Background3Only" : "Background3Only", "Background4Only" : "Background4Only", "Background3AndForeground" : "Background3AndForeground", "Background4AndForeground" : "Background4AndForeground", "ForegroundOnly" : "ForegroundOnly"});

export default SPLM;